import COLORS from '@/constants/colors';

export default {
  button: {
    minWidth: '145px',
    // minWidth: '265px',
    height: '44px',
  },
  outlined: {
    backgroundColor: '#FFFFFF',
    color: COLORS.mercanto_blue,
    border: '1px solid #D0D5DD',
    '&:hover': {
      backgroundColor: COLORS.gray_8,
    },
  },
};
